import React, { useEffect, useState } from 'react';

import styles from './PickupPointItem.module.css'
import {cn} from "../../../../../../../utils/cn.ts";
import { Button } from '../../../../../../../ui/General/Button/Button.tsx';
// import { useMultiStorage } from '../../../../../../../hooks/useStorage.ts';
import { Order } from '../../../../../../../types/Order.interface.ts';
import { DeliveryType } from '../../../../../../../types/Delivery.interface.ts';
import { API_URL } from '../../../../../../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';

export const PickupPointTransportCompanyDeliveryItem: React.FC = () => {
    const dispatch = useAppDispatch();
    const [deliveryType, setDeliveryType] = useState<string>('');
    const [offer, setOffer] = useState<Order|null>(null);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    // const [storage, setStorage] = useMultiStorage({
    //     cartOffer: ['cartOffer', offer],
    //     getCartOffer: ['getCartOffer', false],
    //     getUserData: ['getUserData', false],
    // });


    const setTransportCompanyDeliveryFromValdivostok = () => {
        if(!offer?.cartId) return;

        fetch(`${API_URL}/cart/${offer.cartId}/set_transport_company_delivery_from_valdivostok`, {
            method: 'POST',
            credentials: 'include',
        }).then(() => {
            setDeliveryType(DeliveryType.shipping);
            dispatch(cartOfferLoader({cartId: offer.cartId, isMini: false, all: true}));
            dispatch(userInfoLoader());
            // setStorage('getCartOffer', true);
            // setStorage('getUserData', true);
        })
    }

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            setDeliveryType(cartOffer.delivery.type);
        }
    }, []);

    const selected = deliveryType === DeliveryType.shipping;
    return (
        <div className={cn(styles.isChecked, styles.card)}>
            <div className={styles.header}>
                <h3 className={styles.title}>Доставка транспортной компанией</h3>
            </div>
            <div className={styles.settings}>
                <Button
                    type='regular'
                    className={cn(selected ? styles.chosenBtn : styles.chooseBtn)}
                    onClick={() => {
                        setTransportCompanyDeliveryFromValdivostok()
                    }}
                >
                    {selected ? 'Выбрано' : 'Выбрать'}
                </Button>
            </div>
        </div>
    );
};
